import { Component, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IAction } from '../../../model/action.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable, Subject, tap } from 'rxjs';
import { ProductsService } from 'src/app/services/products.service';
import { IUser } from 'src/app/data-types/user-data';
import { ELabelType } from 'src/app/models/label';

@UntilDestroy()
@Component({
    selector: 'app-new-enquiry-action-form',
    templateUrl: './new-enquiry-action-form.component.html',
    styleUrls: ['./new-enquiry-action-form.component.scss'],
})
export class NewEnquiryActionForm implements OnInit {
    @Input() subFormIsLoading$: Subject<boolean>;
    @Input() form: FormGroup;
    @Input() action: IAction;

    allProducts: any[];
    selectedProducts = [];

    ELabelType = ELabelType;

    constructor(private productsService: ProductsService) {}

    ngOnInit(): void {
        this.loadFormData().subscribe(() => {
            this.extendFormControls();
            this.selectedProducts = this.allProducts.filter((p) => this.action.products.includes(p.id));
            this.subFormIsLoading$.next(false);
        });
    }

    removeProduct(product) {
        this.selectedProducts = this.selectedProducts.filter((p) => p.id !== product.id);
        this.form.get('products').setValue(this.selectedProducts.map((p) => p.id));
    }

    adminSelected(selectedAdmins: IUser[]) {
        const taggedAdminsIds = selectedAdmins.map((a) => a.id);
        this.form.get('taggedAdminsIds').setValue(taggedAdminsIds);
    }

    private loadFormData(): Observable<any> {
        return this.productsService
            .findAll()
            .pipe(untilDestroyed(this))
            .pipe(
                tap((res: any) => {
                    this.allProducts = res.data;
                })
            );
    }

    private extendFormControls() {
        this.form.addControl('description', new FormControl(this.action.description, [Validators.required]));
        this.form.addControl('customerId', new FormControl(this.action.customer?.id));
        this.form.addControl('labels', new FormControl({ ids: this.action.labelIds }));
        if (!this.form.get('taggedAdminsIds')) {
            this.form.addControl('taggedAdminsIds', new FormControl(this.action.taggedAdminsIds));
        }
    }
}
